import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import HomepageEditor from "@/components/admin/cms/HomepageEditor";
import VendorCMS from "@/components/admin/cms/VendorCMS";
import LenderCMS from "@/components/admin/cms/LenderCMS";
import DomainSettings from "@/components/admin/cms/DomainSettings";

const CMSManagement = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">CMS Management</h1>
        <p className="text-muted-foreground">
          Manage content across different platforms with AI assistance
        </p>
      </div>

      <Tabs defaultValue="homepage" className="space-y-4">
        <TabsList>
          <TabsTrigger value="homepage">Homepage</TabsTrigger>
          <TabsTrigger value="vendors">Vendor CMS</TabsTrigger>
          <TabsTrigger value="lenders">Lender CMS</TabsTrigger>
          <TabsTrigger value="domains">Domain Settings</TabsTrigger>
        </TabsList>

        <TabsContent value="homepage" className="space-y-4">
          <HomepageEditor />
        </TabsContent>

        <TabsContent value="vendors" className="space-y-4">
          <VendorCMS />
        </TabsContent>

        <TabsContent value="lenders" className="space-y-4">
          <LenderCMS />
        </TabsContent>

        <TabsContent value="domains" className="space-y-4">
          <DomainSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default CMSManagement;